module.exports = __webpack_public_path__ + "components/page-header/static/mountain-badge--dark-ef85f69d1b3baf43baec20bdfdda0688.svg";